import { Action } from '../types';

export const SUB_NAV_HEIGHT_UPDATE = 'SUB_NAV_HEIGHT_UPDATE';
export const SECTION_INDEX_UPDATE = 'SECTION_INDEX_UPDATE';

export const updateSubNavHeight = (payload: number): Action => ({
  type: SUB_NAV_HEIGHT_UPDATE,
  payload,
});

export const updateSectionIndex = (payload: number): Action => ({
  type: SECTION_INDEX_UPDATE,
  payload,
});

export const mapDispatchToProps = (dispatch: (action: Action) => void) => ({
  updateSubNavHeight: (arg: number) => dispatch(updateSubNavHeight(arg)),
  updateSectionIndex: (arg: number) => dispatch(updateSectionIndex(arg)),
});
